import { useEffect } from "react";
import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
} from "react-router-dom";
import AthletePoll from "./pages/AthletePoll";
import VideoIntro from "./pages/VideoIntro";
import ProductPoll from "./pages/ProductPoll";
import TriviaMarvin from "./pages/TriviaMarvin";
import TriviaWill from "./pages/TriviaWill";
import TriviaChase from "./pages/TriviaChase";

import MarvinCloset from "./pages/MarvinCloset";
import ChaseCloset from "./pages/ChaseCloset";
import WillCloset from "./pages/WillCloset";


import Fortress from "./pages/Fortress";
import Prodigy from "./pages/Prodigy";

import ShopCTA from "./pages/ShopCTA";

import { useState } from 'react';
import styles from "./Global.module.css";
import { createContext } from 'react';

import { AudioContext } from "./AudioContext"

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    if ((typeof umami !== 'undefined')) 
      { 
        setInitialized(true) 
      } else {
        window.umami = undefined
      }
  }, []);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "";
        metaDescription = "";
        break;
      case "/intro-video":
        title = "";
        metaDescription = "";
        break;
      case "/who-best":
        title = "";
        metaDescription = "";
        break;
      case "/marvin-trivia":
        title = "";
        metaDescription = "";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  const [muted, setMuted] = useState(true);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (umami) { setInitialized(true) }
  }, []);

  useEffect(() => {
    if (initialized) {
      umami.track(props => ({ ...props, url: location.pathname + location.search, title: location.pathname + location.search }));
    }
  }, [initialized, location]);

  return (
    <AudioContext.Provider value={{ muted, setMuted }}>
      <Routes>
        <Route path="/" element={<VideoIntro />} />
        <Route path="/who-best" element={<AthletePoll />} />
        <Route path="/marvin-trivia" element={<TriviaMarvin />} />
        <Route path="/will-trivia" element={<TriviaWill />} />
        <Route path="/chase-trivia" element={<TriviaChase />} />

        <Route path="/marvin-closet" element={<MarvinCloset />} />
        <Route path="/chase-closet" element={<ChaseCloset />} />
        <Route path="/will-closet" element={<WillCloset />} />


        <Route path="/product-poll/:athlete" element={<ProductPoll />} />
        <Route path="/shop-cta" element={<ShopCTA />} />
        <Route path="/fortress" element={<Fortress />} />
        <Route path="/prodigy" element={<Prodigy />} />
      </Routes>


    </AudioContext.Provider>
  );
}
export default App;
